import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import PageHeader from './PageHeader';
import { Link } from 'react-router-dom';

const PrivacyPage = () => {
    const { getFullTranslation } = useLanguage();
    const t = getFullTranslation('privacyPage');

    return (
        <div>
            <PageHeader title={t.title} subtitle={t.date} />

            <div className="max-w-3xl mx-auto px-6 py-10 pb-20">
                <p className="text-gray-600 text-[15px] leading-relaxed mb-6">{t.intro}</p>

                <h2 className="text-xl font-bold text-orange-600 mt-8 mb-3 pb-2 border-b-2 border-orange-200">{t.section1}</h2>
                <p className="text-gray-600 text-[15px] leading-relaxed mb-3">{t.section1desc}</p>
                <ul className="pl-5 space-y-2 mb-3">
                    <li className="text-gray-600 text-[15px] list-disc"><strong>{t.item1title}</strong> {t.item1desc}</li>
                    <li className="text-gray-600 text-[15px] list-disc"><strong>{t.item2title}</strong> {t.item2desc}</li>
                    <li className="text-gray-600 text-[15px] list-disc"><strong>{t.item3title}</strong> {t.item3desc}</li>
                </ul>

                <h2 className="text-xl font-bold text-orange-600 mt-8 mb-3 pb-2 border-b-2 border-orange-200">{t.section2}</h2>
                <ul className="pl-5 space-y-2 mb-3">
                    <li className="text-gray-600 text-[15px] list-disc">{t.section2desc1}</li>
                    <li className="text-gray-600 text-[15px] list-disc">{t.section2desc2}</li>
                    <li className="text-gray-600 text-[15px] list-disc">{t.section2desc3}</li>
                </ul>

                <h2 className="text-xl font-bold text-orange-600 mt-8 mb-3 pb-2 border-b-2 border-orange-200">{t.section3}</h2>
                <p className="text-gray-600 text-[15px] leading-relaxed mb-3 font-semibold">{t.section3p1}</p>
                <p className="text-gray-600 text-[15px] leading-relaxed mb-3">{t.section3p2}</p>

                <h3 className="text-base font-semibold text-gray-800 mt-6 mb-2">{t.section31}</h3>
                <p className="text-gray-600 text-[15px] leading-relaxed mb-3">{t.section31p1}</p>
                <ul className="pl-5 space-y-2 mb-3">
                    <li className="text-gray-600 text-[15px] list-disc">{t.section31item1}</li>
                    <li className="text-gray-600 text-[15px] list-disc">{t.section31item2}</li>
                    <li className="text-gray-600 text-[15px] list-disc">{t.section31item3}</li>
                </ul>
                <p className="text-gray-500 text-sm italic mb-3">{t.section31p2}</p>
                <p className="text-gray-600 text-[15px] leading-relaxed mb-3">{t.section31p3}</p>

                <h2 className="text-xl font-bold text-orange-600 mt-8 mb-3 pb-2 border-b-2 border-orange-200">{t.section4}</h2>
                <ul className="pl-5 space-y-2 mb-3">
                    <li className="text-gray-600 text-[15px] list-disc"><strong>{t.section4item1}</strong> {t.section4item1desc}</li>
                    <li className="text-gray-600 text-[15px] list-disc"><strong>{t.section4item2}</strong> {t.section4item2desc}</li>
                    <li className="text-gray-600 text-[15px] list-disc"><strong>{t.section4item3}</strong> {t.section4item3desc}</li>
                </ul>

                <h2 className="text-xl font-bold text-orange-600 mt-8 mb-3 pb-2 border-b-2 border-orange-200">{t.section5}</h2>
                <p className="text-gray-600 text-[15px] leading-relaxed mb-3">{t.section5desc}</p>

                <h2 className="text-xl font-bold text-orange-600 mt-8 mb-3 pb-2 border-b-2 border-orange-200">{t.section6}</h2>
                <p className="text-gray-600 text-[15px] leading-relaxed mb-3">{t.section6desc}</p>

                <h2 className="text-xl font-bold text-orange-600 mt-8 mb-3 pb-2 border-b-2 border-orange-200">{t.section7}</h2>
                <p className="text-gray-600 text-[15px] leading-relaxed mb-3">{t.section7desc}</p>
                <ul className="pl-5 mb-3">
                    <li className="text-gray-600 text-[15px] list-disc">{t.contactSite}: <a href="https://shiguangjiapp.com" className="text-orange-600 hover:underline">shiguangjiapp.com</a></li>
                </ul>

                <p className="mt-6 text-gray-400 text-xs">{t.footerNote}</p>
                <Link to="/" className="inline-block mt-8 text-orange-600 font-medium hover:underline">{t.back}</Link>
            </div>
        </div>
    );
};

export default PrivacyPage;
